// import { FakeSubmit } from '@gunnarssongroup/fake-submit';
import { Dictionary } from 'utils/Dictionary'
import { RemoveOrderLine, AddToCart } from 'components'
import dayjs = require('dayjs')
import { FakeSubmit } from '@gunnarssongroup/fake-submit'

const Cart = {
  el: {
    cart: document.querySelector<HTMLElement>('.cart'),
    items: document.querySelectorAll<HTMLElement>('.cart-item'),
    delete: document.querySelectorAll<HTMLButtonElement>('.cart__product-remove'),
    empty: document.querySelector<HTMLElement>('.cart__empty'),
    total: document.querySelector<HTMLElement>('.cart__total'),
    buttonRow: document.querySelector<HTMLElement>('.cart__button-row'),
    qtyBubble: document.querySelector<HTMLElement>('.top__qty'),
    addForms: document.querySelectorAll<HTMLFormElement>('.cart__qty-form'),
    summary: document.querySelector<HTMLElement>('.cart-summary'),
    typeSelections: document.querySelectorAll<HTMLSelectElement>('.cart__type-selector-choice'),
    daySelections: document.querySelectorAll<HTMLSelectElement>('.day-selector__day input'),
    checkoutButton: document.querySelector<HTMLAnchorElement>('.cart-summary__button-row .button'),
    dayForm: document.querySelector<HTMLFormElement>('.checkout__rental-form'),
    cartLoader: document.querySelector<HTMLFormElement>('.cart-loader'),
  },

  init() {
    if (this.el.cart) {
      this.removeItem()
      this.updateQty()

      if (this.el.dayForm)
      {
        this.typeChange()
        this.daySelection()
        // this.goToCheckout()
        this.handleDaySubmit()
      }
    }
  },

  typeChange() {
    Array.prototype.forEach.call(document.querySelectorAll('.cart__type-selector-choice'), async (item: HTMLInputElement) => {
      item.addEventListener('change', async (e: Event & { target: HTMLInputElement }) => {
        const typeText = this.el.summary.querySelector('.cart-summary__section.first .cart-summary__section-title')
        const fromInput = document.querySelector('.day-selector__day--from input') as HTMLInputElement
        const toInput = document.querySelector('.day-selector__day--to input') as HTMLInputElement
        const toDay = this.el.summary.querySelector('.cart-summary__item-value--to')
        const parent = toInput.parentElement.parentElement.parentElement as HTMLElement
        console.log('target', e.target.value);
        

        if (e.target.value === '1') {
          typeText.innerHTML = Dictionary('TypeSelectionSummary24Hour')
          
          toInput.setAttribute('disabled', '')

          parent.classList.remove('day-selector__double')
          parent.classList.add('day-selector__single')

          if (fromInput.value.length > 0) {
            toInput.value = this.handleAddOneDay(fromInput.value)
            toDay.innerHTML = this.handleAddOneDay(fromInput.value)
          }
          else {
            toInput.value = ''
            toDay.innerHTML = ''
          }

          setTimeout(() => {
            toInput.removeAttribute('disabled')
            console.log('type change', toInput.value)
            FakeSubmit(this.el.dayForm)
          }, 0);
        }
        else {
          if (toInput.value.length > 0) {
            toInput.value = ''
            toDay.innerHTML = ''
          }

          toInput.removeAttribute('disabled')
          typeText.innerHTML = Dictionary('TypeSelectionSummaryLongTime')
          parent.classList.remove('day-selector__single')
          parent.classList.add('day-selector__double')
        }

        if (this.validate()) {
          this.el.checkoutButton.removeAttribute('disabled')
        }
        else {
          this.el.checkoutButton.setAttribute('disabled', '')
        }
      })
    })
  },

  handleAddOneDay(value) {
    const split = value.split('.')
    const formatDate = new Date(`${split[1]}-${split[0]}-${split[2]}`)

    return dayjs(formatDate).add(1, 'day').format('DD.MM.YYYY')
  },

  daySelection() {
    Array.prototype.forEach.call(this.el.daySelections, (item: HTMLInputElement) => {
      item.addEventListener('blur', (e: Event & { target: HTMLInputElement }) => {
        const fromDay = this.el.summary.querySelector('.cart-summary__item-value--from')
        const toDay = this.el.summary.querySelector('.cart-summary__item-value--to')

        const fromInput = document.querySelector('.day-selector__day--from input') as HTMLInputElement
        const toInput = document.querySelector('.day-selector__day--to input') as HTMLInputElement

        const parent = e.target.parentElement.parentElement.parentElement as HTMLElement

        // console.log('blur');
        
        if (fromInput.value.length > 0) {
          if (parent.classList.contains('day-selector__single')) {            
            toInput.value = this.handleAddOneDay(fromInput.value)
          }
          
          fromDay.innerHTML = fromInput.value
          toDay.innerHTML = toInput.value
          
          // if (this.validate()) {
          //   this.el.checkoutButton.removeAttribute('disabled')
          // }

        }

        if (fromInput.value.length > 0) {
          toInput.removeAttribute('disabled')
          
          FakeSubmit(this.el.dayForm)
        }
      })
    })
  },

  async handleDaySubmit() {
    this.el.dayForm.addEventListener('submit', (e: Event & { target: HTMLFormElement }) => {
      e.preventDefault()

      this.daySubmit(this.el.dayForm)
    })
  },

  async daySubmit(
    form: HTMLFormElement,
  ){
    console.log('toinput from submit', document.querySelector<HTMLInputElement>('.day-selector__day--to input').value)
    const formData = new FormData(form)
    //@ts-ignore
    const dataString = new URLSearchParams(formData).toString()
  
    this.el.cartLoader.style.display = 'flex'

  
    const response = await fetch(form.getAttribute('action'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: dataString
    })

    // TODO: add error messaging
  
    if (response.ok) {
      // const data = await response.json()

      window.location.reload()
    }
    else {
      this.el.cartLoader.style.display = 'none'
    }
  },

  validate(): boolean {
    const days = document.querySelectorAll('.day-selector__day input')
    let isValid = true

    Array.prototype.forEach.call(days, (item: HTMLInputElement) => {      
      if (item.value.length === 0) {
        
        isValid = false
      }
    })

    return isValid
  },

  // goToCheckout() {
  //   this.el.checkoutButton.addEventListener('click', (e: Event & { target: HTMLAnchorElement }) => {
  //     e.preventDefault()

  //     this.daySubmit(this.el.dayForm, e.target.href)
  //   })
  // },

  removeItem(): void {
    Array.prototype.forEach.call(this.el.items, (item: HTMLElement) => {
      const form = <HTMLFormElement>item.querySelector('.cart__form')

      form.addEventListener('submit', (e: Event) => {
        e.preventDefault()

        RemoveOrderLine(form).then(() => window.location.reload())
      })
    })
  },

  updateQty(): void {
    Array.prototype.forEach.call(this.el.items, (item: HTMLElement) => {
      const increment = item.querySelector<HTMLButtonElement>('[data-increment]')
      const decrement = item.querySelector<HTMLButtonElement>('[data-decrement]')
      const form = item.querySelector<HTMLFormElement>('.cart__qty-form')

      increment.addEventListener('click', (e: Event & { target: HTMLButtonElement }) => {
        this.handleQtyClick(form, false)
      })

      decrement.addEventListener('click', (e: Event & { target: HTMLButtonElement }) => {
        this.handleQtyClick(form, true)
      })

    })
  },

  handleQtyClick(form: HTMLFormElement, direction: boolean): void {
    // updateQuantity(form).then()
    // updateBubble(form, direction, false)
    this.handleQtySubmit()
  },

  handleQtySubmit() {
    Array.prototype.forEach.call(this.el.addForms, (item: HTMLFormElement) => {
      item.addEventListener('submit', (e) => {
        e.preventDefault();
        AddToCart(null, item).then((s) => window.location.reload()) 
      })
    })
  },
}

export default Cart
